<script lang="ts" setup>
import { DgrDialog } from '@stockmarkteam/donguri-ui';
import OrganizationTagLabels from '../others/organization-tags/organization-tag-labels.vue';

defineProps<{ tagNameList: string[] }>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const hideModal = () => {
  emit('close');
  return true;
};
</script>

<template>
  <DgrDialog
    :open="true"
    title="組織タグ"
    :close-interceptor-handler="hideModal"
    :close-on-escape="false"
  >
    <template #description>
      <div class="label-wrapper">
        <OrganizationTagLabels :labels="tagNameList" :deletable="false" />
      </div>
    </template>

    <template #footer>
      <button class="c-btn c-btn--small c-btn--auto" @click="() => hideModal()">
        閉じる
      </button>
    </template>
  </DgrDialog>
</template>

<style lang="scss" scoped>
.label-wrapper {
  max-height: 55vh;
  overflow-y: auto;
  padding-left: 8px;
}
</style>
